import { useCallback, useState } from 'react'

import type { ChartData } from 'chart.js'

import { EditLineChartDialog } from '../action-dialogs/edit-chart'
import { useCustomizableValue } from '../hooks/use-customizable-value'
import { ChartCustomizerProvider } from '../state/chart-customizer'

interface Props {
  entityName: string
  data?: ChartData<'line'>
  children: (props: {
    data?: ChartData<'line'>
    totalValue: number | string
  }) => JSX.Element
  dateRange: string
  totalValue: number | string
  chartLineColor: string
}

export const LineChartEditorWrapper = ({
  children,
  data,
  entityName,
  dateRange,
  totalValue,
  chartLineColor,
}: Props) => {
  const [isLineChartDialogOpen, setIsLineChartDialogOpen] = useState(false)
  const chart = useCustomizableValue({
    name: `${entityName}.chart`,
    originalValue: data,
    dateRange,
  })

  const total = useCustomizableValue({
    name: `${entityName}.total`,
    originalValue: totalValue,
    dateRange,
  })

  const onOpenLineChartDialog = useCallback(() => {
    setIsLineChartDialogOpen(true)
  }, [setIsLineChartDialogOpen])

  return (
    <ChartCustomizerProvider
      onClickEditLineChart={onOpenLineChartDialog}
      onEditTotalValue={total.onChange}
    >
      {children({ data: chart.value, totalValue: total.value })}

      <EditLineChartDialog
        isOpen={isLineChartDialogOpen}
        onClose={() => setIsLineChartDialogOpen(false)}
        entity={entityName}
        data={chart.value}
        onEdit={chart.onChange}
        chartLineColor={chartLineColor}
      />
    </ChartCustomizerProvider>
  )
}
